/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React, { type ReactNode } from 'react';
import { useHistory } from 'react-router';

import { ListeTable, ListeTableContainer } from '@mairistem/liste';

import { baseUrlApp } from '@/routes';
import ActeNaissanceListeTableRow from './ActeNaissanceListeTableRow';

interface ActeNaissanceListeTableProps {
  items?: Array<any>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad: any;
  onSort: any;
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeNaissanceListeTable = (props: ActeNaissanceListeTableProps) => {
  const { items, count, perPage, loading, onLoad, onSort, sidebar } = props;

  const history = useHistory();

  const renderRow = (item: any) => (
    <ActeNaissanceListeTableRow item={item} sidebar={sidebar} />
  );

  const handleSelect = (selectedItem: any) => {
    const identifiant = selectedItem?.identifiant ?? selectedItem?.id;
    if (identifiant != null) {
      history.push(`${baseUrlApp}naissance/${identifiant}`);
    }
  };

  const listItems = React.useMemo(() => {
    const list = items || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (list as any[]).map((item) => {
      if (item?.identifiant == null && item?.id != null) {
        return { ...item, identifiant: item.id };
      }
      return item;
    });
  }, [items]);

  return (
    <ListeTableContainer
      // @ts-ignore
      items={listItems}
    >
      <ListeTable
        items={listItems}
        loading={loading}
        perPage={perPage}
        count={count}
        onLoad={onLoad}
        onSort={onSort}
        onSelect={handleSelect}
      >
        {/* Colonnes en enfants DIRECTS du Header : cf. MentionListeTable. */}
        {sidebar ? (
          <ListeTable.Header>
            <ListeTable.Column name="nom" width={16}>
              Nom
            </ListeTable.Column>
          </ListeTable.Header>
        ) : (
          <ListeTable.Header>
            <ListeTable.Column name="registre" width={2}>
              Registre
            </ListeTable.Column>
            <ListeTable.Column name="typeActe" width={3}>
              Type d&apos;acte
            </ListeTable.Column>
            <ListeTable.Column name="numero" sortable width={2}>
              N° acte et ordre
            </ListeTable.Column>
            <ListeTable.Column name="dresse" sortable width={2}>
              Dressé
            </ListeTable.Column>
            <ListeTable.Column name="dateNaissance" sortable width={1}>
              Naissance
            </ListeTable.Column>
            <ListeTable.Column name="enfant" width={2}>
              Enfant
            </ListeTable.Column>
            <ListeTable.Column name="parent1" width={2}>
              Parent 1
            </ListeTable.Column>
            <ListeTable.Column name="parent2" width={2}>
              Parent 2
            </ListeTable.Column>
          </ListeTable.Header>
        )}
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </ListeTableContainer>
  );
};

export default ActeNaissanceListeTable;
